import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { useNavigate } from "react-router-dom";
import { Button, Grid } from "@mui/material";
import Zoom from "react-medium-image-zoom";
// import UploadIcon from "@mui/icons-material/Upload";
import CreateIcon from "@mui/icons-material/Create";
// import DeleteIcon from "@mui/icons-material/Delete";

function BuildingDetails() {
  const navigate = useNavigate();

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Krushna Building</h1>
            {/* <Button className="contentTopLefBt">Download</Button> */}
            <Button className="primaryBtn" onClick={() => navigate("")}>
              <CreateIcon /> &nbsp; Edit Building
            </Button>
          </Grid>

          <Grid item xs={12} md={12}>
            <div className="buildingYesMainNew">
              <div className="buildingYesImgeOut">
                <img src="https://www.satyamevgroups.com/blog/wp-content/uploads/2019/12/residential-apartment-in-patna.jpg" alt="altimg"/>
              </div>
              <div className="buldingInnerContent">
                <Grid container spacing={3}>
                  <Grid item xs={12} md={12}>
                    <div className="buildingDoqumentsDiv">
                      <p className="totalWingsHed">
                        Total wings <b>4</b>
                      </p>
                      <h4 className="doquProviderHed">Documents</h4>
                      <div className="tabViewOfProviderRight">
                        <div className="doquOut">
                          <div className="doquView1">
                            <Zoom>
                              <div className="doquView">
                                <img src="https://images1.livehindustan.com/uploadimage/library/2022/02/20/16_9/16_9_1/fake_aadhaar_card_1645316141.jpg"  alt="altimg"/>
                              </div>
                            </Zoom>
                            <span>adharcard.jpg</span>
                          </div>
                        </div>
                        <div className="doquOut">
                          <div className="doquView1">
                            <Zoom>
                              <div className="doquView">
                                <img src="https://upload.wikimedia.org/wikipedia/commons/3/31/A_sample_of_Permanent_Account_Number_%28PAN%29_Card.jpg" alt="altimg"/>
                              </div>
                            </Zoom>
                            <span>pancard.jpg</span>
                          </div>
                          <div className="doquView2"></div>
                        </div>
                      </div>
                    </div>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <div className="tenentLeftContentMain">
                      <ul>
                        <li className="addedApartCont activeTenent">
                          {/* <DeleteIcon className="delIc" /> */}
                          <h4>
                            <p>Wing-A</p>
                          </h4>
                          <span> Total apartments : 120</span>
                        </li>
                        <li className="addedApartCont">
                          {/* <DeleteIcon className="delIc" /> */}
                          <h4>
                            <p>Wing-A</p>
                          </h4>
                          <span> Total apartments : 120</span>
                        </li>
                        <li className="addedApartCont">
                          {/* <DeleteIcon className="delIc" /> */}
                          <h4>
                            <p>Wing-A</p>
                          </h4>
                          <span> Total apartments : 120</span>
                        </li>
                      </ul>
                    </div>
                  </Grid>
                  <Grid item xs={12} md={8}>
                    <div className="wingsTablsMainDiv priceTbMain">
                      <table width="100%">
                        <thead>
                          <tr className="thColr">
                            <th colSpan={4}>Wing A</th>
                            <th style={{ textAlign: "right" }}>Edit WIng</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td colSpan={1}>Floors</td>
                            <td colSpan={4}>Apartments</td>
                          </tr>
                          <tr>
                            <td>Floor 1</td>
                            <td>101</td>
                            <td>102</td>
                            <td>103</td>
                            <td>104</td>
                          </tr>
                          <tr>
                            <td>Floor 1</td>
                            <td>101</td>
                            <td>102</td>
                            <td>103</td>
                            <td>104</td>
                          </tr>
                          <tr>
                            <td>Floor 1</td>
                            <td>101</td>
                            <td>102</td>
                            <td>103</td>
                            <td>104</td>
                          </tr>
                          <tr>
                            <td>Floor 1</td>
                            <td>101</td>
                            <td>102</td>
                            <td>103</td>
                            <td>104</td>
                          </tr>
                          <tr>
                            <td>Floor 1</td>
                            <td>101</td>
                            <td>102</td>
                            <td>103</td>
                            <td>104</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default BuildingDetails;
